import React from 'react';
import { XIcon } from 'lucide-react';
import './StudentHistoryModal.css';

const sortDataByPeriodDescending = (dataArray) => {
    if (!dataArray || dataArray.length === 0) return [];

    return [...dataArray].sort((a, b) => {
        const periodA_str = a.periodo || a.period;
        const periodB_str = b.periodo || b.period;

        if (!periodA_str) return 1;
        if (!periodB_str) return -1;

        const periodRegex = /^\d{4}\.\d$/;
        if (!periodRegex.test(periodA_str) && !periodRegex.test(periodB_str)) return 0;
        if (!periodRegex.test(periodA_str)) return 1;
        if (!periodRegex.test(periodB_str)) return -1;

        const [yearA, semA] = periodA_str.split('.').map(Number);
        const [yearB, semB] = periodB_str.split('.').map(Number);

        if (yearB !== yearA) {
            return yearB - yearA;
        }
        return semB - semA;
    });
};

const getGradeStatusClass = (notaValue) => {
    if (!notaValue || notaValue === "N/A") return 'default';
    const numericValue = parseFloat(String(notaValue));
    if (isNaN(numericValue)) return 'default';

    if (numericValue === 10) return 'perfect';
    if (numericValue >= 8) return 'positive';
    if (numericValue >= 7) return 'warning';
    return 'danger';
};


const StudentHistoryModal = ({ isOpen, onClose, student }) => {
    if (!isOpen || !student) {
        return null;
    }

    const sortedGradeHistoryData = sortDataByPeriodDescending(student.disciplinas || []);
    const sortedAttendanceSummaryData = sortDataByPeriodDescending(student.periodAttendanceSummary || []);

    return (
        <div className="shm-modal-overlay">
            <div role="dialog" className="shm-modal-content">

                <button onClick={onClose} className="shm-close-button">
                    <XIcon className="shm-close-icon" />
                    <span className="shm-sr-only">Fechar</span>
                </button>

                <div className="shm-header">
                    <h2 className="shm-title">Histórico do Aluno</h2>
                </div>
                <p className="shm-description">
                    Histórico acadêmico de {student.name}
                </p>

                <div className="shm-body-sections-wrapper">
                    <div className="shm-history-section">
                        <h4 className="shm-section-heading">Evolução das Notas</h4>
                        <div className="shm-table-like-container">
                            <div className="shm-table-like-header shm-grid-cols-3">
                                <div>Período</div>
                                <div>Disciplina</div>
                                <div className="shm-text-center">Nota</div>
                            </div>
                            {sortedGradeHistoryData.map(item => (
                                <div key={`grade-${item.id || item.nome}`} className="shm-table-like-row shm-grid-cols-3">
                                    <div>{item.periodo}</div>
                                    <div>{item.nome}</div>
                                    <div className="shm-text-center">
                                        <span className={`shm-grade-text shm-grade-${getGradeStatusClass(item.nota)}`}>
                                            {item.nota}
                                        </span>
                                    </div>
                                </div>
                            ))}
                            {sortedGradeHistoryData.length === 0 && (
                                <div className="shm-table-like-row shm-no-data">
                                    Nenhum dado de notas disponível.
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="shm-history-section">
                        <h4 className="shm-section-heading">Histórico de Frequência</h4>
                        <div className="shm-table-like-container">
                            <div className="shm-table-like-header shm-grid-cols-2">
                                <div>Período</div>
                                <div className="shm-text-center">Frequência</div>
                            </div>
                            {sortedAttendanceSummaryData.map(item => (
                                <div key={`freq-${item.id || item.period}`} className="shm-table-like-row shm-grid-cols-2">
                                    <div>{item.period}</div>
                                    <div className="shm-text-center">
                                        <span className={`shm-grade-text shm-grade-${getGradeStatusClass(item.frequency)}`}>
                                            {item.frequency}
                                        </span>
                                    </div>
                                </div>
                            ))}
                            {sortedAttendanceSummaryData.length === 0 && (
                                <div className="shm-table-like-row shm-no-data">
                                    Nenhum dado de frequência por período disponível.
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="shm-footer">
                    <button onClick={onClose} className="shm-button-primary">
                        Fechar
                    </button>
                </div>

            </div>
        </div>
    );
};

export default StudentHistoryModal;